// A text template is written for one kind of Bullhorn record. That decides which fields it can pull
// in and which record the sender is previewing it against.
const RECORDS = {
  candidate: {
    label: 'Candidate',
    fieldsLabel: 'Candidate fields',
    fieldSource: 'From the candidate record',
    searchPlaceholder: 'Search candidate fields',
  },
  contact: {
    label: 'Contact',
    fieldsLabel: 'Contact fields',
    fieldSource: 'From the contact record',
    searchPlaceholder: 'Search contact fields',
  },
  placement: {
    label: 'Placement',
    fieldsLabel: 'Placement fields',
    fieldSource: 'From the placement',
    searchPlaceholder: 'Search placement fields',
  },
};

// Text templates were placement-only to begin with, so anything unrecognised reads as a placement.
export function textTemplateEntity(entityType) {
  const key = String(entityType || '').toLowerCase();
  return RECORDS[key] ? key : 'placement';
}

export function textTemplateRecord(entityType) {
  return RECORDS[textTemplateEntity(entityType)];
}

// Who the template is written for. A candidate or contact template goes to that person; a placement
// template is signed by the candidate on the placement.
export function textTemplateRecipients(entityType) {
  const entity = textTemplateEntity(entityType);
  return {
    send_to_candidate: entity !== 'contact',
    send_to_contact: entity === 'contact',
  };
}
